import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fw-bold mb-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-8" }
const _hoisted_4 = { class: "d-flex align-items-center w-100" }
const _hoisted_5 = { class: "d-flex align-items-center w-100 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "fs_24 fw_700",
  style: {"margin-top":"-7px","display":"block"}
}, "+", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex justify-content-end mt-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "table table-striped" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "99" }
const _hoisted_13 = { class: "valuesTable" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.localValue.garmentConfigurationLayerName), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_form_field, {
            type: "select-string",
            labelKey: "Gender",
            labelValue: "Gender",
            placeholderKey: "Gender",
            placeholderValue: "Gender",
            list: _ctx.localValue.genderValues,
            modelValue: _ctx.vm.gender,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.gender) = $event)),
            class: "me-1 w-100"
          }, null, 8, ["list", "modelValue"]),
          _createVNode(_component_form_field, {
            type: "select-string",
            labelKey: "Property",
            labelValue: "Property",
            placeholderKey: "Property",
            placeholderValue: "Property",
            list: _ctx.localValue.properties,
            modelValue: _ctx.vm.propertyName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.propertyName) = $event)),
            class: "ms-1 w-100"
          }, null, 8, ["list", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_form_field, {
            type: "text",
            labelKey: "Label",
            labelValue: "Label",
            placeholderKey: "Label",
            placeholderValue: "Label",
            modelValue: _ctx.tempValue.label,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempValue.label) = $event)),
            class: "w-100 me-1"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Value",
            labelValue: "Value",
            placeholderKey: "Value",
            placeholderValue: "Value",
            modelValue: _ctx.tempValue.value.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempValue.value.value) = $event)),
            class: "w-100 mx-1"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "form-group pointer w-100 ms-2",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tempValue.value.isPercentage = !_ctx.tempValue.value.isPercentage))
          }, [
            _createVNode(_component_localized_text, {
              type: "label",
              class: "d-block",
              localizedKey: "Is percentage",
              text: "Is percentage"
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.tempValue.value.isPercentage}])
            }, null, 2)
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary ms-2",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addValue()))
          }, _hoisted_7)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-secondary me-2",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('prev')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Previous",
          text: "Previous"
        })
      ])
    ]),
    _hoisted_9,
    _createElementVNode("table", _hoisted_10, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Gender",
              text: "Gender"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Property",
              text: "Property"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Values",
              text: "Values"
            })
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.localValue.propertyValues.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No Elements Found",
                  text: "No Elements Found"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.propertyValues, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(item.gender), 1),
            _createElementVNode("td", null, _toDisplayString(item.propertyName), 1),
            _createElementVNode("td", null, [
              _createElementVNode("table", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (jtem, i) => {
                  return (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-primary me-1",
                        onClick: ($event: any) => (_ctx.removeValue(item, jtem))
                      }, "-", 8, _hoisted_15)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(jtem.label), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(jtem.value.value) + " ", 1),
                      (jtem.value.isPercentage)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("%")
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 256))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}